import * as React from 'react';
import { createSvgIcon } from '@fluentui/react-icons-mdl2';

const AdminALogoInverse32Icon = createSvgIcon({
  svg: ({ classes }) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2048 2048" className={classes.svg}>
      <path d="M1407 1025q0 26-10 49t-27 40-41 27-49 10V897q26 0 49 10t40 27 28 41 10 50zm613 84l-63 240-210-28q-17 26-35 50t-41 46l73 191-214 125-128-167q-60 15-122 15v-209q72 0 135-27t110-74 74-111 27-135q0-71-27-134t-74-110-110-74-135-28V464h5l79-178 240 63-27 204q27 17 51 37t48 43l187-71 124 214-166 127q13 59 13 124l186 82zM619 779q17 80 36 158t38 159l-151-2q19-79 38-157t36-158h3zM64 272L1216 67v1914L64 1782V272zm276 1099l134 8 40-159 211 7 44 170 156 10-224-766-158 10-203 720z" />
    </svg>
  ),
  displayName: 'AdminALogoInverse32Icon',
});

export default AdminALogoInverse32Icon;
